import API_ENDPOINTS from "../config/apiEndpoints";
import { request, requestWithAuth } from "./apiClient";

export const apiLoginService = {
  postLogin: async (login) => {
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(login),
    };
    const response = await request(API_ENDPOINTS.LOGIN.EMPRESA, requestOptions);
    if (!response.ok) {
      let errorData = null;
      try {
        errorData = await response.json();
      } catch (error) {
        errorData = null;
      }
      throw new Error(errorData?.message || errorData?.error || "Error en la autenticacion");
    }
    return response.json();
  },

  postLoginUser: async (login) => {
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(login),
    };
    return request(API_ENDPOINTS.LOGIN.EMPLEADO, requestOptions);
  },

  getValidateToken: async () => {
    const response = await requestWithAuth(API_ENDPOINTS.LOGIN.VALIDAR, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });
    return response.json();
  },

  getEmpresaId: async (empresa) => {
    const response = await requestWithAuth(API_ENDPOINTS.LOGIN.EMPRESA_ID(empresa), {
      method: "GET",
    });
    return response.json();
  },

  getUserId: async (empresaNombre, usuario) => {
    const response = await requestWithAuth(
      API_ENDPOINTS.LOGIN.USER_ID(empresaNombre, usuario),
      {
        method: "GET",
      }
    );
    return response.json();
  },

  putPassword: async (UserID, json) => {
    const requestOptions = {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(json),
    };
    const response = await requestWithAuth(
      API_ENDPOINTS.LOGIN.UPDATE_PASSWORD(UserID),
      requestOptions
    );
    return response.json();
  },
};
